import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
//import { withStyles } from '../styles';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { MenuBar } from 'data/components';
import uiTheme from 'data/common/uiTheme';

import LayoutGeneric from 'environments/genericEnv/layouts';
import Layoutmyfhe from 'environments/myfhe/layouts';
import Layouttestbench from 'environments/testbench/layouts';
import Layoutlogging from 'environments/logging/layouts';
import Layoutsimulationenr from 'environments/simulationenr/layouts';
import Layoutticketsgit from 'environments/ticketsgit/layouts';
import Layoutfhe from 'environments/fhe/layouts';
import Layoutfhepool from 'environments/fhepool/layouts';

import Background from '../../assets/images/background-appmenu.jpg';

class SecuredLayout extends Component {
    layoutEnvironments = {
        myfhe: Layoutmyfhe,
        testbench: Layouttestbench,
        logging: Layoutlogging,
        simulationenr: Layoutsimulationenr,
        ticketsgit: Layoutticketsgit,
        fhe: Layoutfhe,
        fhepool: Layoutfhepool,
        cocoon: LayoutGeneric,
        fheconnect: LayoutGeneric,
        homing: LayoutGeneric,
        lacin: LayoutGeneric,
        domalisa: LayoutGeneric,
        accesshabitat: LayoutGeneric,
        maestro: LayoutGeneric,
        weezeo: LayoutGeneric,
        niceenergie: LayoutGeneric,
        mghabitat: LayoutGeneric,
        idealys: LayoutGeneric,
        inogreen: LayoutGeneric,
    };
    static propTypes = {
        children: PropTypes.object.isRequired,
        environment: PropTypes.string.isRequired,
        mainRoutes: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
    };

    static contextTypes = {
        changeTheme: PropTypes.func,
    };

    componentDidMount() {
        const { changeTheme } = this.context;
        const { environment } = this.props;
        changeTheme(uiTheme(environment));
    }

    render() {
        const { children, environment, classes, mainRoutes, location } = this.props;
        let background = location.modal && location.modal.background;

        if (this.layoutEnvironments[environment]) {
            const LayoutEnv = this.layoutEnvironments[environment];

            return (
                <div className="d-flex flex-fill flex-column">
                    <MenuBar environment={environment} mainRoutes={mainRoutes} />
                    <LayoutEnv environment={environment}>{children}</LayoutEnv>
                    <div className={`${classes.backgroundStyle} ${background ? classes.backgroundForModal : classes.backgroundWithoutModal}`} />
                </div>
            );
        } else {
            return (
                <div className="d-flex flex-fill flex-column">
                    {children}
                    <div className={classes.backgroundStyle} />
                </div>
            );
        }
    }
}

function mapStateToProps() {
    return {};
}

const styles = theme => ({
    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.8em'
        },
        '*::-webkit-scrollbar-track': {
            backgroundColor: `${theme.palette.primary.light}`,
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: `${theme.palette.primary.main}`,
            outline: '1px solid slategrey'
        },
        a: {
            '&:hover': {
                color: `${theme.palette.primary.main}`
            }
        }
    },
    backgroundStyle: {
        background: `radial-gradient(circle, transparent 80%, black 150%), linear-gradient(to top, ${theme.palette.primary.main} -30%, transparent 120%), url(${Background})`,
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundBlendMode: 'overlay',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
    },
    backgroundForModal: {
        zIndex: 5
    },
    backgroundWithoutModal: {
        zIndex: 0
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}), dispatch)
    )(withStyles(styles, { withTheme: true })(SecuredLayout))
);



// WEBPACK FOOTER //
// ./layouts/Secured/index.js